import 'formdata-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { ApolloProvider } from 'react-apollo';
import { ThemeProvider } from 'styled-components';
import { BrowserRouter, Route, Redirect, Switch } from 'react-router-dom';
import './styles/global';
import LoginPage from './pages/login';
import SignupPage from './pages/sign-up';
import HomePage from './pages/home';
import theme from './styles/theme';
import client from './core/apollo';
import ErrorPage from './pages/error';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(
  <ApolloProvider client={client}>
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Switch>
          <Route path="/login" component={LoginPage} />
          <Route path="/signup" component={SignupPage} />
          <Route exact path="/error" component={ErrorPage} />
          <Route
            path="/"
            render={props =>
              !!localStorage.getItem('jwt') ? (
                <HomePage {...props} />
              ) : (
                <Redirect {...props} to="/signup" />
              )
            }
          />
          <Route component={ErrorPage} />
        </Switch>
      </BrowserRouter>
    </ThemeProvider>
  </ApolloProvider>,
  document.getElementById('root')
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js